/**
 * Store admin (org dashboard) sign-in URL for onboarding emails.
 * Set `ORG_DASHBOARD_LOGIN_URL` in `.env` (exposed via `envPrefix` in `vite.config.ts`), or set the same key on the API.
 */
export function getOrgDashboardLoginUrl(): string {
  return String(import.meta.env.ORG_DASHBOARD_LOGIN_URL ?? '').trim()
}
